import React from "react";
import { MapPin } from "lucide-react";
import type { PropertyFormData } from "../../types";

interface AddressSectionProps {
  formData: Partial<PropertyFormData>;
}

// Helper function to format ZIP code (show first 5 digits)
const formatZipCode = (zip?: string): string => {
  if (!zip) return "";
  return zip.substring(0, 5);
};

const AddressSection: React.FC<AddressSectionProps> = ({ formData }) => {
  const addressParts = [
    formData.zip_code ? formatZipCode(formData.zip_code) : null,
    formData.city || formData.ort || null,
    formData.street || null,
    formData.house_number || null,
  ].filter(Boolean);

  const address =
    addressParts.length > 0
      ? addressParts.join(", ")
      : "Adresse wird eingegeben...";

  return (
    <div className="flex items-start gap-3 py-3">
      <MapPin className="w-5 h-5 text-prime-700 mt-0.5 shrink-0" />
      <div className="flex-1 min-w-0">
        <h3 className="text-sm font-medium text-gray-700 mb-1.5 font-sans">
          Standort
        </h3>
        <p className="text-base font-medium text-gray-900 font-serif break-words">
          {address}
        </p>
      </div>
    </div>
  );
};

export default AddressSection;
